/** Fechas de reportes en formato dd/MM/yyyy (convención SMARTNET). */

export function isoADisplayDDMMAAAA(iso) {
  if (!iso) return '';
  const part = String(iso).split('T')[0];
  const [y, m, d] = part.split('-');
  if (!y || !m || !d) return '';
  return `${d.padStart(2, '0')}/${m.padStart(2, '0')}/${y}`;
}

/** dd-MM-yyyy con guiones (encabezados tipo impreso legado). */
export function isoADisplayDDMMYYYYGuiones(iso) {
  if (!iso) return '';
  const part = String(iso).split('T')[0];
  const [y, m, d] = part.split('-');
  if (!y || !m || !d) return '';
  return `${d.padStart(2, '0')}-${m.padStart(2, '0')}-${y}`;
}

/**
 * Interpreta dd/MM/yyyy o dd-MM-yyyy (1-2 dígitos día/mes, año 2 o 4 dígitos).
 * Devuelve yyyy-mm-dd o null si no es válido.
 */
export function displayDDMMAAAAISO(str) {
  const s = String(str ?? '').trim();
  if (!s) return null;
  const m = s.match(/^(\d{1,2})[/-](\d{1,2})[/-](\d{2,4})$/);
  if (!m) return null;
  let d = Number(m[1]);
  let mo = Number(m[2]);
  let y = Number(m[3]);
  if (m[3].length === 2) y += 2000;
  if (!Number.isInteger(d) || !Number.isInteger(mo) || !Number.isInteger(y)) return null;
  if (mo < 1 || mo > 12 || d < 1 || d > 31) return null;
  const iso = `${String(y).padStart(4, '0')}-${String(mo).padStart(2, '0')}-${String(d).padStart(2, '0')}`;
  const dt = new Date(y, mo - 1, d);
  if (Number.isNaN(dt.getTime())) return null;
  if (dt.getFullYear() !== y || dt.getMonth() !== mo - 1 || dt.getDate() !== d) return null;
  return iso;
}
